/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListGlobalVariationsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListGlobalVariationsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListGlobalVariationsSecurity = {
  option1?: ListGlobalVariationsSecurityOption1 | undefined;
  option2?: ListGlobalVariationsSecurityOption2 | undefined;
};

export type ListGlobalVariationsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListGlobalVariationsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListGlobalVariationsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListGlobalVariationsSecurityOption1$Outbound,
  ListGlobalVariationsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listGlobalVariationsSecurityOption1ToJSON(
  listGlobalVariationsSecurityOption1: ListGlobalVariationsSecurityOption1,
): string {
  return JSON.stringify(
    ListGlobalVariationsSecurityOption1$outboundSchema.parse(
      listGlobalVariationsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListGlobalVariationsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListGlobalVariationsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListGlobalVariationsSecurityOption2$Outbound,
  ListGlobalVariationsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listGlobalVariationsSecurityOption2ToJSON(
  listGlobalVariationsSecurityOption2: ListGlobalVariationsSecurityOption2,
): string {
  return JSON.stringify(
    ListGlobalVariationsSecurityOption2$outboundSchema.parse(
      listGlobalVariationsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListGlobalVariationsSecurity$Outbound = {
  Option1?: ListGlobalVariationsSecurityOption1$Outbound | undefined;
  Option2?: ListGlobalVariationsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListGlobalVariationsSecurity$outboundSchema: z.ZodMiniType<
  ListGlobalVariationsSecurity$Outbound,
  ListGlobalVariationsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListGlobalVariationsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListGlobalVariationsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listGlobalVariationsSecurityToJSON(
  listGlobalVariationsSecurity: ListGlobalVariationsSecurity,
): string {
  return JSON.stringify(
    ListGlobalVariationsSecurity$outboundSchema.parse(
      listGlobalVariationsSecurity,
    ),
  );
}

/** @internal */
export type ListGlobalVariationsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListGlobalVariationsRequest$outboundSchema: z.ZodMiniType<
  ListGlobalVariationsRequest$Outbound,
  ListGlobalVariationsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listGlobalVariationsRequestToJSON(
  listGlobalVariationsRequest: ListGlobalVariationsRequest,
): string {
  return JSON.stringify(
    ListGlobalVariationsRequest$outboundSchema.parse(
      listGlobalVariationsRequest,
    ),
  );
}
